import { html, nothing } from "lit-html";

import { FormField } from "./sc-e-form-field";
import { DISABLED } from "Constants/cssClasses";
import { FormFieldLabelRenderArgs, FormFieldRenderArgs } from "./sc-e-form-field.types";

/**
 * Returns the input placeholder
 * @param {string} label
 * @param {boolean} isRequired
 * @returns {string}
 */
export const appendRequiredAsterisk = (label: string, isRequired: boolean): string => {
  if (label === "") return "";
  return `${label}${isRequired ? " *" : ""}`;
};

const errorBox = (errorMessage: string) => {
  return html` <span class="sc-e-form-field__error"> ${errorMessage} </span> `;
};

const constraintErrorBox = (constraintMessage: string) => {
  return html` <span class="sc-e-form-field__constraint-error"> ${constraintMessage} </span> `;
};

export const descriptionBox = (description: string) => {
  if (description === "") return "";
  return html` <span class="sc-e-form-field__description"> ${description} </span> `;
};

export const getError = (showError: boolean, errorMessage: string) => {
  return showError ? errorBox(errorMessage) : html``;
};

export const getConstraintError = (showConstraintError: boolean, constraintMessage: string) => {
  return showConstraintError ? constraintErrorBox(constraintMessage) : html``;
};

/**
 * Return TemplateResult of form-field label
 * @param {GetLabelArgs} args
 * @returns {TemplateResult}
 */
export const getLabel = (args: FormFieldLabelRenderArgs) => {
  if (args.label === "") return "";
  return html`
    <label
      class="sc-e-form-field__label${args.isDisabled || args.isReadonly ? ` ${DISABLED}` : ""}"
      for="${args.for}"
      id=${args.id ? args.id : nothing}
    >
      ${appendRequiredAsterisk(args.label, args.isRequired)}
    </label>
  `;
};

export const getInfoBox = <T, G extends FormField<T>>(args: FormFieldRenderArgs<T, G>) => {
  return html`
    <div class="sc-e-text-input__info-box" id="info-box-${args.formField.id}">
      ${descriptionBox(args.formField.description)}
      ${getError(args.formField.state.showError, args.formField.errorMessage)}
      ${getConstraintError(args.formField.state.showConstraintError, args.formField.constraintMessage)}
    </div>
  `;
};
